
import { HomepageComponent } from './app/homepage/homepage.component';

import { Routes } from '@angular/router'
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { RolesComponent } from './app/ultilities/roles/roles.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './app/ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './app/ultilities/claims/claims/claim-form/claim-form.component';
import { AuthGuard } from './app/auth/auth.guard';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
import { VehicleGridComponent } from './app/ultilities/vehicle/vehicle-grid/vehicle-grid.component';
import { VehicleFormComponent } from './app/ultilities/vehicle/vehicle-form/vehicle-form.component';
import { ForgotPasswordComponent } from './app/registration/forgot-password/forgot-password.component';


import { ClientComponent } from './app/pages/home/client/client.component';
import { LicenceFormComponent } from './app/pages/functions/licence/licence-form/licence-form.component';
import { LicenceGridComponent } from './app/pages/functions/licence/licence-grid/licence-grid.component';

import { SalaryComponent } from './app/pages/functions/salary-slips/salary/salary.component';
import { ArmDetailsFormComponent } from './app/pages/functions/arm-details/arm-details-form/arm-details-form.component';
import { ClientsFormComponent } from './app/pages/view/clients/clients-form/clients-form.component';
import { ClientsGridComponent } from './app/pages/view/clients/clients-grid/clients-grid.component';
import { EmployeesGridComponent } from './app/pages/view/other-employess/employees-grid/employees-grid.component';
import { GuardsGridComponent } from './app/pages/view/guards/guards-grid/guards-grid.component';
import { SupervisorGridComponent } from './app/pages/view/supervisor/supervisor-grid/supervisor-grid.component';
import { OfficerComponent } from './app/pages/view/field-officer/officer/officer.component';
import { ManagementComponent } from './app/pages/view/management-details/management/management.component';
import { BranchGridComponent } from './app/pages/view/branch-details/branch-grid/branch-grid.component';
import { BranchFormComponent } from './app/pages/view/branch-details/branch-form/branch-form.component';
import { PsaCriminalProceedingsListComponent } from './app/pages/home/psa-criminal-proceedings-list/psa-criminal-proceedings-list.component';
import { ViewDetailsComponent } from './app/pages/view/view-details/view-details.component';
import { MasterDetailsComponent } from './app/pages/master/master-details/master-details.component';

import { DistictGridComponent } from './app/pages/master/district/distict-grid/distict-grid.component';
import { DistictFormComponent } from './app/pages/master/district/distict-form/distict-form.component';
import { ArmDetailsComponent } from './app/pages/functions/arm-details/arm-details.component';

import { NotificationFormComponent } from './app/pages/functions/notification/notification-form/notification-form.component';
import { NotificationGridComponent } from './app/pages/functions/notification/notification-grid/notification-grid.component';
import { EmpHistoryComponent } from './app/pages/functions/emp-history/emp-history.component';
import { CriminalQueriesComponent } from './app/pages/functions/staff-criminal-proceedings/criminal-queries/criminal-queries.component';
import { ViewCriminalEmpComponent } from './app/pages/functions/staff-criminal-proceedings/view-criminal-emp/view-criminal-emp.component';
import { ReportForm2Component } from './app/pages/functions/report-form2/report-form2.component';
import { LicenceRequestMenuComponent } from './app/pages/functions/lience-reuest/licence-request-menu/licence-request-menu.component';
import { PsadetailsFormComponent } from './app/pages/functions/psadetails/psadetails-form/psadetails-form.component';
import { PsadetailsGridComponent } from './app/pages/functions/psadetails/psadetails-grid/psadetails-grid.component';
import { FunctionsComponent } from './app/pages/functions/functions.component';
import { MasterComponent } from './app/pages/master/master.component';
import { ViewComponent } from './app/pages/view/view.component';
import { HomeIsDepartmentComponent } from './app/pages/home/home-is-department/home-is-department.component';
import { HomeComponent } from './app/pages/home/home.component';

import { AppComponent } from './app/khb.component';

import { UserComponent } from './app/ultilities/user/user.component';

import { ClaimsComponent } from './app/ultilities/claims/claims/claims.component';

import { SettingComponent } from './app/ultilities/setting/setting.component';

import { PetitionComponent } from './app/petition/petition.component';
import { PetitionGridComponent } from './app/petition/petition-grid/petition-grid.component';
import { PetitionFormComponent } from './app/petition/petition-form/petition-form.component';
import { PetitionApprovalComponent } from './app/petition/petition-approval/petition-approval.component';

import { PetitionApprovalGridComponent } from './app/petition/petition-approval-grid/petition-approval-grid.component';
import { CorrespondanceTrackingComponent } from './app/correspondance-tracking/correspondance-tracking.component';
import { CtGridComponent } from './app/correspondance-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './app/correspondance-tracking/ct-form/ct-form.component';

import { RptFormComponent } from './app/pages/view/rpt-form/rpt-form.component';
import { PsadetailsComponent } from './app/pages/functions/psadetails/psadetails.component';
import { ManagementFormComponent } from './app/pages/view/management-details/management-form/management-form.component';
import { GuardsFormComponent } from './app/pages/view/guards/guards-form/guards-form.component';
import { ArmDetailsViewComponent } from './app/pages/functions/arm-details/arm-details-view/arm-details-view.component';
import { NewArmDetailsFormComponent } from './app/pages/functions/arm-details/new-arm-details-form/new-arm-details-form.component';
import { SupervisorFormComponent } from './app/pages/view/supervisor/supervisor-form/supervisor-form.component';

import { LienceReuestFormComponent } from './app/pages/functions/lience-reuest/lience-reuest-form/lience-reuest-form.component';
import { PsaTrainingComponent } from './app/pages/functions/training-details/psa-training/psa-training.component';
import { TrainingDetailsFormComponent } from './app/pages/functions/training-details/training-details-form/training-details-form.component';
import { TrainingCertificateComponent } from './app/pages/functions/training-details/training-certificate/training-certificate.component';
import { HomeMenuComponent } from './app/pages/home/home-menu/home-menu.component';
import { PersonnelComponent } from './app/pages/functions/personnel-details/Personnels/personnel/personnel.component';
import { PersonnelFormComponent } from './app/pages/functions/personnel-details/Personnels/personnel-form/personnel-form.component';
import { PersonnelRelievingComponent } from './app/pages/functions/personnel-details/Personnel-Relievings/personnel-relieving/personnel-relieving.component';
import { PersonnelRelievingFormComponent } from './app/pages/functions/personnel-details/Personnel-Relievings/personnel-relieving-form/personnel-relieving-form.component';
import { ExistingPersonnelComponent } from './app/pages/functions/personnel-details/Personnels/existing-personnel/existing-personnel.component';
import { NewPersonnelComponent } from './app/pages/functions/personnel-details/Personnels/new-personnel/new-personnel.component';
import { UpdatePersonnelGridComponent } from './app/pages/functions/personnel-details/Update-Personnel-Details/update-personnel-grid/update-personnel-grid.component';
import { UpdatePersonnelComponent } from './app/pages/functions/personnel-details/Update-Personnel-Details/update-personnel/update-personnel.component';
import { PersonnelHestoryComponent } from './app/pages/functions/personnel-details/Personnels/personnel-hestory/personnel-hestory.component';
import { MainPageComponent } from './app/pages/Main/main-page/main-page.component';
import { HomePageComponent } from './app/pages/main/home-page/home-page.component';
import { AboutUsPageComponent } from './app/pages/Main/about-us-page/about-us-page.component';
import { ContactUsPageComponent } from './app/pages/Main/contact-us-page/contact-us-page.component';
import { OtherActsPageComponent } from './app/pages/Main/other-acts-page/other-acts-page.component';
import { RegisterPageComponent } from './app/pages/Main/register-page/register-page.component';
import { VerifyPersonelPageComponent } from './app/pages/Main/verify-personel-page/verify-personel-page.component';
import { DistrictListComponent } from './app/pages/Main/district-list/district-list.component';
import { EmployeeFormComponent } from './app/pages/view/other-employess/employee-form/employee-form.component';
import { PsaListDetailsComponent } from './app/pages/main/psa-list-details/psa-list-details.component';
import { PsaNotificationsComponent } from './app/pages/main/psa-notifications/psa-notifications.component';
import { RelatedWebsitesComponent } from './app/pages/main/related-websites/related-websites.component';
import { DistrictWiseReportComponent } from './app/pages/view/rpt-form/report-list/district-wise-report/district-wise-report.component';
import { LicencePendingUserListComponent } from './app/pages/view/rpt-form/report-list/licence-pending-user-list/licence-pending-user-list.component';
import { LicencePenddingListComponent } from './app/pages/view/rpt-form/report-list/licence-pendding-list/licence-pendding-list.component';
import { LicenseRejectedListComponent } from './app/pages/view/rpt-form/report-list/license-rejected-list/license-rejected-list.component';
import { PsaBranchAddressDetailsComponent } from './app/pages/functions/psadetails/psa-list/psa-branch-address-details/psa-branch-address-details.component';
import { PsaClientsComponent } from './app/pages/functions/psadetails/psa-list/psa-clients/psa-clients.component';
import { PsaFieldOfficerComponent } from './app/pages/functions/psadetails/psa-list/psa-field-officer/psa-field-officer.component';
import { PsaGuardsComponent } from './app/pages/functions/psadetails/psa-list/psa-guards/psa-guards.component';
import { PsaLicenceComponent } from './app/pages/functions/psadetails/psa-list/psa-licence/psa-licence.component';
import { PsaManagementComponent } from './app/pages/functions/psadetails/psa-list/psa-management/psa-management.component';
import { PsaOtherEmployeesComponent } from './app/pages/functions/psadetails/psa-list/psa-other-employees/psa-other-employees.component';
import { PsaSalarySlipsComponent } from './app/pages/functions/psadetails/psa-list/psa-salary-slips/psa-salary-slips.component';
import { PsaSupervisorsComponent } from './app/pages/functions/psadetails/psa-list/psa-supervisors/psa-supervisors.component';
import { PsaLicenceReqGridComponent } from './app/pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-grid/psa-licence-req-grid.component';
import { ViewPsaForm2RenewalComponent } from './app/pages/functions/psadetails/view-psa-form2-renewal/view-psa-form2-renewal.component';
import { ViewForm2Component } from './app/pages/functions/psadetails/view-form2/view-form2.component';
import { ViewForm5Component } from './app/pages/functions/psadetails/view-form5/view-form5.component';
import { DocInfoRequiredPsaComponent } from './app/pages/functions/psadetails/doc-info-required-psa/doc-info-required-psa.component';
import { Form2Component } from './app/pages/functions/psadetails/form2/form2.component';
import { Form5Component } from './app/pages/functions/psadetails/form5/form5.component';
import { DocInfoRequiredPsaAddComponent } from './app/pages/functions/psadetails/doc-info-required-psa-add/doc-info-required-psa-add.component';
import { Form2ViewCriminalProceedingComponent } from './app/pages/functions/staff-criminal-proceedings/form2-view-criminal-proceeding/form2-view-criminal-proceeding.component';
import { Form4ViewComponent } from './app/pages/functions/form4-view/form4-view.component';
import { PfComplianceGridComponent } from './app/pages/functions/pf-compliances/pf-compliance-grid/pf-compliance-grid.component';
import { EsiComplianceGridComponent } from './app/pages/functions/esi-compliances/esi-compliance-grid/esi-compliance-grid.component';
import { PfComplianceViewComponent } from './app/pages/functions/pf-compliances/pf-compliance-view/pf-compliance-view.component';
import { EsiComplianceViewComponent } from './app/pages/functions/esi-compliances/esi-compliance-view/esi-compliance-view.component';
import { FieldOfficerFormComponent } from './app/pages/view/field-officer/field-officer-form/field-officer-form.component';
import { TrainingCertificateGridComponent } from './app/pages/functions/training-certificate/training-certificate-grid/training-certificate-grid.component';
import { TrainingCertificateViewComponent } from './app/pages/functions/training-certificate/training-certificate-view/training-certificate-view.component';
import { TrainingCertificateFormComponent } from './app/pages/functions/training-certificate/training-certificate-form/training-certificate-form.component';
import { NewCriminalEventGridComponent } from './app/pages/functions/criminal-events/new-criminal-event-grid/new-criminal-event-grid.component';
import { NewCriminalEventViewComponent } from './app/pages/functions/criminal-events/new-criminal-event-view/new-criminal-event-view.component';
import { CriminalProceedGridComponent } from './app/pages/functions/criminal-proceedings/criminal-proceed-grid/criminal-proceed-grid.component';
import { CriminalProceedFormComponent } from './app/pages/functions/criminal-proceedings/criminal-proceed-form/criminal-proceed-form.component';
import { CriminalProceedViewComponent } from './app/pages/functions/criminal-proceedings/criminal-proceed-view/criminal-proceed-view.component';
import { Form4Component } from './app/pages/functions/form4/form4.component';
import { NewArmDetailsViewComponent } from './app/pages/functions/arm-details/new-arm-details-view/new-arm-details-view.component';
import { HomeTempRegistraionComponent } from './app/pages/home/home-temp-registraion/home-temp-registraion.component';
import { NotificationInfoComponent } from './app/pages/home/notification-info/notification-info.component';
import { BulkUploadComponent } from './app/ultilities/bulk-upload/bulk-upload.component';


export const appRoutes: Routes = [
    {
        path: 'menu', component: HomepageComponent, canActivate: [AuthGuard],
        children: [
            {
                path: 'password', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },

            {
                path: 'password/:userId', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },
            {
                path: 'bulk-upload', component: UltilitiesComponent,
                children: [{ path: '', component: BulkUploadComponent }]
            },
           
            {
                path: 'rolesgrid', component: UltilitiesComponent,
                children: [
                    { path: '', component: RolesGridComponent },
                    { path: 'rolesform', component: RolesFormComponent },
                    { path: 'rolesform/:roleId/:mode', component: RolesFormComponent },
                ]
            },
            
            {
                path: 'userlist', component: UltilitiesComponent,
                children: [
                    { path: '', component: UserGridComponent },
                    { path: 'userform', component: UserFormComponent },
                    { path: 'userform/:Id/:mode', component: UserFormComponent },
                ]
            },
            
            {
                path: 'claimslist', component: UltilitiesComponent,
                children: [
                    { path: '', component: ClaimGridComponent },
                    { path: 'claimform', component: ClaimFormComponent },
                    { path: 'claimform/:roleId/:roleName', component: ClaimFormComponent }                   
                ]
            },

          
            {
                path: 'petition', component: PetitionComponent,
                children: [{ path: '', component: PetitionGridComponent }]
            },
            {
                path: 'new-petition', component: PetitionComponent,
                children: [{ path: '', component: PetitionFormComponent }]
            },
            {
                path: 'petitionapproval', component: PetitionComponent,
                children: [{ path: '', component: PetitionApprovalGridComponent }]
            },
            {
                path: 'petitionapprovalform', component: PetitionComponent,
                children: [{ path: '', component: PetitionApprovalComponent }]
            },
            {
                path: 'vehicle', component: UltilitiesComponent,
                children: [{ path: '', component: VehicleGridComponent }]
            },
            {
                path: 'vehicleform', component: UltilitiesComponent,
                children: [{ path: '', component: VehicleFormComponent }]
            },

            {
                path: 'correspondancetracking', component: CorrespondanceTrackingComponent,
                children: [{ path: '', component: CtGridComponent }]
            },
            {
                path: 'correspondancetracking-form', component: CorrespondanceTrackingComponent,
                children: [{ path: '', component: CtFormComponent }]
            },

            // main           
            {
                path: 'home', component: HomeComponent,
                children: [     
                    { path: '', component: HomeIsDepartmentComponent },
                    { path: 'home-temp-registration', component: HomeTempRegistraionComponent,
                        children:[                          
                            
                        ]
                    },  
                    { path:'view-psa-form2-renewal', component:ViewPsaForm2RenewalComponent },                    
                    { path:'form5', component:Form5Component },
                    { path:'doc-info-required-psa-add', component:DocInfoRequiredPsaAddComponent },
                    {                        
                        path: 'client-details', component: HomeMenuComponent,
                        children: [
                            { path: '', component: ClientComponent },
                        ]                        
                    },
                    { path: 'notification-info', component: NotificationInfoComponent},

                ]
            },           

            {
                path: 'view', component: ViewComponent,
                children: [
                    {
                        path: '', component: ViewDetailsComponent,
                        children: [
                            { path: '', component: RptFormComponent },
                            { path: 'branch-grid/branch-form', component: BranchFormComponent },
                            { path: 'branch-grid', component: BranchGridComponent },
                            { path: 'management', component: ManagementComponent },
                            { path: 'management/management-form', component: ManagementFormComponent },
                            { path: 'feild-officer', component: OfficerComponent },
                            { path: 'feild-officer/feild-officer-form', component: FieldOfficerFormComponent },
                            { path: 'supervisor', component: SupervisorGridComponent },
                            { path: 'supervisor/supervisor-form', component: SupervisorFormComponent },
                            { path: 'guards', component: GuardsGridComponent },
                            { path: 'guards/guards-form', component: GuardsFormComponent },
                            { path: 'employees', component: EmployeesGridComponent },
                            { path: 'employees/employees-form', component: EmployeeFormComponent },

                            { path: 'client-grid', component: ClientsGridComponent },
                            { path: 'client-form', component: ClientsFormComponent },
                        ]
                    }
                ]
            },
            {
                path: 'master', component: MasterComponent,
                children: [
                    {
                        path: '', component: MasterDetailsComponent,
                        children: [
                            { path: '', component: DistictGridComponent },
                            { path: 'district-form', component: DistictFormComponent }
                        ]
                    }

                ]
            },
            {
                path: 'functions', component: FunctionsComponent,
                children: [
                    {
                        path: '', component: PsadetailsComponent,
                        children: [
                            { path: '', component: PsadetailsGridComponent },
                            { path: 'psa-details-form', component: PsadetailsFormComponent },
                            { path: 'licence', component: LicenceGridComponent },
                            { path: 'licence/licence-form', component: LicenceFormComponent },
                            { path: 'licence-renewal', component: PsaLicenceReqGridComponent },

                            { path: 'licence-request', component: LicenceRequestMenuComponent },
                            { path: 'licence-request/licence-request-form', component: LienceReuestFormComponent },
                            { path: 'report-form2', component: ReportForm2Component },
                            { path: 'view-criminal-emp', component: ViewCriminalEmpComponent },

                            { path: 'criminal-queries', component: CriminalQueriesComponent },
                            { path: 'form-2-view-criminal-proceedings', component: Form2ViewCriminalProceedingComponent },

                            { path: 'emp-history', component: EmpHistoryComponent },
                            { path: 'notification', component: NotificationGridComponent },
                            { path: 'notification/notification-form', component: NotificationFormComponent },
                            { path: 'psa-training', component: PsaTrainingComponent },
                            { path: 'training-form', component: TrainingDetailsFormComponent },
                            { path: 'training-certificate', component: TrainingCertificateComponent },
                            
                            { path: 'arm-details', component: ArmDetailsComponent },
                            { path: 'arm-details/arm-details-form', component: ArmDetailsFormComponent },
                            { path: 'arm-details/arm-details-view', component: ArmDetailsViewComponent },
                            { path: 'arm-details/arm-details-view/new-arm-details', component: NewArmDetailsFormComponent },
                            { path: 'new-arm-details-view', component: NewArmDetailsViewComponent },

                            { path: 'salary-slip', component: SalaryComponent },
                            { path: 'personnel', component: PersonnelComponent },
                            { path: 'personnel/personnel-form', component: PersonnelFormComponent },
                            { path: 'personnel-relieving', component: PersonnelRelievingComponent },
                            { path: 'personnel-relieving-form', component: PersonnelRelievingFormComponent },
                            { path: 'personnel/exits-personnel', component: ExistingPersonnelComponent },
                            { path: 'personnel/new-personnel', component: NewPersonnelComponent },
                            { path: 'personnel-history', component: PersonnelHestoryComponent },
                            { path: 'update-personel', component: UpdatePersonnelGridComponent },
                            { path: 'update-personel/update-personel-form', component: UpdatePersonnelComponent },
                            // 
                            { path: 'psa-branch-address', component: PsaBranchAddressDetailsComponent },
                            { path: 'psa-clients', component: PsaClientsComponent },
                            { path: 'psa-field-officer', component: PsaFieldOfficerComponent },
                            { path: 'psa-guards', component: PsaGuardsComponent },
                            { path: 'psa-licence', component: PsaLicenceComponent },
                            { path: 'psa-management', component: PsaManagementComponent },
                            { path: 'psa-other-employees', component: PsaOtherEmployeesComponent },
                            { path: 'psa-salary-slips', component: PsaSalarySlipsComponent },
                            { path: 'psa-supervisor', component: PsaSupervisorsComponent },
                            { path: 'licence-renewal-request', component: PsaLicenceReqGridComponent },
                            { path: 'view-psa-form2-renewal', component: ViewPsaForm2RenewalComponent },
                            { path: 'view-form2', component: ViewForm2Component },
                            { path: 'view-form5', component: ViewForm5Component },
                            { path: 'doc-info-required-psa', component: DocInfoRequiredPsaComponent },
                            { path: 'form2', component: Form2Component },
                            { path: 'form4', component: Form4Component },  
                            { path: 'form5', component: Form5Component },  
                            { path: 'doc-info-required-psa-add', component: DocInfoRequiredPsaAddComponent },
                            { path: 'form4-view', component: Form4ViewComponent },
                            { path: 'pf-compliance', component:PfComplianceGridComponent },
                            { path: 'pf-compliance/pf-compliance-view', component:PfComplianceViewComponent },
                            { path: 'esi-compliance', component:EsiComplianceGridComponent },
                            { path: 'esi-compliance/esi-compliance-view', component:EsiComplianceViewComponent },

                            { path : 'training-certificate-grid' , component:TrainingCertificateGridComponent },
                            { path : 'training-certificate-form' ,component :TrainingCertificateFormComponent },
                            { path : 'training-certificate-view', component :TrainingCertificateViewComponent },                            
                            
                            { path : 'criminal-proceeding', component:CriminalProceedGridComponent },
                            { path : 'criminal-proceeding-form' ,component :CriminalProceedFormComponent },
                            { path : 'criminal-proceeding-view', component :CriminalProceedViewComponent },
                            
                            { path : 'new-criminal-event-add', component : NewCriminalEventGridComponent },
                            { path : 'new-criminal-event-view', component : NewCriminalEventViewComponent },
                        ]

                    }
                ]
            },

            // main end



        ]
    },

    {
        path: 'signup', component: RegistrationComponent,
        children: [{ path: '', component: SignupComponent }]
    },
    {
        path: 'forgot-password', component: RegistrationComponent,
        children: [{ path: '', component: ForgotPasswordComponent }]
    },

    {
        path: 'main', component: MainPageComponent,
        children: [
            { path: '', component: HomePageComponent },
            { path: 'about-us', component: AboutUsPageComponent },
            { path: 'contact-us', component: ContactUsPageComponent },
            { path: 'other-acts', component: OtherActsPageComponent },
            { path: 'register-page', component: RegisterPageComponent },
            { path: 'verify-personnel', component: VerifyPersonelPageComponent },
            { path: 'district-list', component: DistrictListComponent },
            { path: 'psa-list-details', component: PsaListDetailsComponent },           
            { path: 'login', component: LoginComponent}
        ]

    },   

    { path: 'psa-criminal-proceedings-list', component: PsaCriminalProceedingsListComponent },

    // Reports

    { path: 'district-wise-report', component: DistrictWiseReportComponent },
    { path: 'licence-pendding-list', component: LicencePenddingListComponent },
    { path: 'licence-pending-user-list', component: LicencePendingUserListComponent },
    { path: 'license-rejected-list', component: LicenseRejectedListComponent },

    // { path: '', redirectTo: '/login', pathMatch: 'full' },

    { path: '', redirectTo: '/main', pathMatch: 'full' }




];


// WEBPACK FOOTER //
// ./src/route.ts